import { render, staticRenderFns } from "./ListeDossiersAttenteRgpd.vue?vue&type=template&id=6cbaf6b6&"
import script from "./ListeDossiersAttenteRgpd.vue?vue&type=script&lang=ts&"
export * from "./ListeDossiersAttenteRgpd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports